"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _timepickerComponents = require("./timepickerComponents");

var _unique = _interopRequireDefault(require("../helpers/unique.id"));

var _getNativeProps = _interopRequireDefault(require("../helpers/get-native-props"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Timepicker =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Timepicker, _React$Component);

  function Timepicker(props) {
    var _this;

    _classCallCheck(this, Timepicker);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Timepicker).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "updateHours", function (value) {
      _this.setState({
        hours: value,
        selfUpdate: true
      }, _this.onChange);
    });

    _defineProperty(_assertThisInitialized(_this), "updateMinutes", function (value) {
      _this.setState({
        minutes: value,
        selfUpdate: true
      }, _this.onChange);
    });

    _defineProperty(_assertThisInitialized(_this), "updateMeridian", function (meridian) {
      _this.setState({
        meridian: meridian,
        selfUpdate: true
      }, _this.onChange);
    });

    _defineProperty(_assertThisInitialized(_this), "onChange", function () {
      var _this$state = _this.state,
          hours = _this$state.hours,
          minutes = _this$state.minutes,
          meridian = _this$state.meridian;

      _this.props.onChange({
        hours: hours,
        minutes: minutes,
        meridian: meridian
      });
    });

    _this.state = {
      hours: props.hours || props.defaultHours,
      minutes: props.minutes || props.defaultMinutes,
      meridian: props.meridian || props.defaultMeridian,
      selfUpdate: false
    };
    _this.id = _this.props.id || (0, _unique.default)();
    return _this;
  }

  _createClass(Timepicker, [{
    key: "render",
    value: function render() {
      var hoursId = "".concat(this.id, "-hours");
      var minutesId = "".concat(this.id, "-minutes");
      var meridianId = "".concat(this.id, "-meridian");
      var _this$state2 = this.state,
          hours = _this$state2.hours,
          minutes = _this$state2.minutes,
          meridian = _this$state2.meridian;
      var _this$props = this.props,
          format24H = _this$props.format24H,
          daySpan = _this$props.daySpan;
      return _react.default.createElement("div", _extends({
        className: "co-timepicker"
      }, (0, _getNativeProps.default)(this.props)), _react.default.createElement(_timepickerComponents.NumberStepper, {
        id: hoursId,
        minValue: format24H ? 0 : 1,
        maxValue: format24H ? daySpan * 24 - 1 : 12,
        minLength: 2,
        value: hours,
        onChange: this.updateHours
      }), _react.default.createElement("span", null, ":"), _react.default.createElement(_timepickerComponents.NumberStepper, {
        id: minutesId,
        minValue: 0,
        maxValue: 59,
        minLength: 2,
        value: minutes,
        onChange: this.updateMinutes
      }), !format24H ? _react.default.createElement(_timepickerComponents.TimepickerSwitch, {
        id: meridianId,
        defaultMeridian: meridian,
        onChange: this.updateMeridian
      }) : null);
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      var hours = props.hours,
          minutes = props.minutes,
          meridian = props.meridian;
      var currHours = state.hours,
          currMinutes = state.minutes,
          currMeridian = state.meridian;
      return state.selfUpdate ? _objectSpread({}, state, {
        selfUpdate: false
      }) : {
        hours: hours || currHours,
        minutes: minutes || currMinutes,
        meridian: meridian || currMeridian,
        selfUpdate: false
      };
    }
  }]);

  return Timepicker;
}(_react.default.Component);

Timepicker.defaultProps = {
  onChange: function onChange() {},
  daySpan: 1,
  defaultHours: 0,
  defaultMinutes: 0,
  defaultMeridian: 'AM'
};
Timepicker.propTypes = {
  id: _propTypes.string,
  format24H: _propTypes.bool,
  hours: _propTypes.number,
  minutes: _propTypes.number,
  meridian: _propTypes.string,
  defaultHours: _propTypes.number,
  defaultMinutes: _propTypes.number,
  defaultMeridian: _propTypes.string,
  onChange: _propTypes.func,

  /** Prop to allow multiple day time affection in case of some user wants to select more than 24h */
  daySpan: _propTypes.number
};
var _default = Timepicker;
exports.default = _default;
Timepicker.__docgenInfo = {
  "description": "",
  "methods": [{
    "name": "updateHours",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "value",
      "type": null
    }],
    "returns": null
  }, {
    "name": "updateMinutes",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "value",
      "type": null
    }],
    "returns": null
  }, {
    "name": "updateMeridian",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "meridian",
      "type": null
    }],
    "returns": null
  }, {
    "name": "onChange",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }],
  "displayName": "Timepicker",
  "props": {
    "onChange": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "daySpan": {
      "defaultValue": {
        "value": "1",
        "computed": false
      },
      "type": {
        "name": "number"
      },
      "required": false,
      "description": "Prop to allow multiple day time affection in case of some user wants to select more than 24h"
    },
    "defaultHours": {
      "defaultValue": {
        "value": "0",
        "computed": false
      },
      "type": {
        "name": "number"
      },
      "required": false,
      "description": ""
    },
    "defaultMinutes": {
      "defaultValue": {
        "value": "0",
        "computed": false
      },
      "type": {
        "name": "number"
      },
      "required": false,
      "description": ""
    },
    "defaultMeridian": {
      "defaultValue": {
        "value": "'AM'",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "id": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "format24H": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "hours": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": ""
    },
    "minutes": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": ""
    },
    "meridian": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    }
  }
};